var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_tick-circle",
    "data-name": "vuesax/outline/tick-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75,19.5A9.75,9.75,0,1,1,19.5,9.75,9.758,9.758,0,0,1,9.75,19.5Zm0-18.14a8.39,8.39,0,1,0,8.39,8.39A8.4,8.4,0,0,0,9.75,1.36Z",
    transform: "translate(1.25 1.25)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.578,7.168a.749.749,0,0,1-.53-.22L.218,4.117a.75.75,0,0,1,1.06-1.06l2.3,2.3L8.718.218a.75.75,0,0,1,1.06,1.06l-5.67,5.67A.749.749,0,0,1,3.578,7.168Z",
    transform: "translate(6.003 7.413)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H22V22H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.c6641324a72fb5d1a6ef987ed65ecca5.svg";
export { ForwardRef as ReactComponent };